import { useParse, useTranslation } from "@refinedev/core";
import { Overview } from "./overview"
import { Link, useLocation } from "react-router-dom";
import { Event } from "./event";
import { UserType } from "interfaces";
import WPSDashboardOverview from "routes/wps/dashboard/overview";
import WPSDashboardEent from "routes/wps/dashboard/event";

export const Dashboard: React.FC = () => {
  const parse = useParse();
  const { translate } = useTranslation();
  const location = useLocation();
  const { params } = parse();
  const user = JSON.parse(localStorage.getItem("USER") ?? "{}");
  const isWps = user?.type === UserType.WPS;
  const currentTab = params?.id === "event" || location.pathname.endsWith("/event") ? "event" : "overview";

  return (
    <div>
      <div className="border-b border-solid border-[#A7B4FE] mb-2 sm:mb-4">
        <div className="relative w-full flex items-center md:max-w-sm">
          <Link to={"/dashboard/overview"} className={`flex-1 h-[36px] text-center ${currentTab === "overview" ? "text-brand-500 font-medium" : ""}`}>
            <button>{translate("overview")}</button>
          </Link>
          <Link to={"/dashboard/event"} className={`flex-1 h-[36px] text-center ${currentTab === "event" ? "text-brand-500 font-medium" : ""}`}>
            <button>{translate("event")}</button>
          </Link>
          <div className="absolute bottom-0 left-0 w-[50%] h-1 bg-brand-400 rounded-t-xl transition-all" style={{marginLeft: `calc(50% * ${currentTab === "overview" ? 0 : 1})`}}></div>
        </div>
      </div>
      {currentTab === "overview" ? (
        isWps ? <WPSDashboardOverview hideDashboardLayout /> : <Overview />
      ) : (
        isWps ? <WPSDashboardEent hideDashboardLayout /> : <Event />
      )}
    </div>
  )
}
